<template>
  <div class="content-container">
    <div class="content-box">
      <div ref="agGridWrapper" class="section-box outline">
        <search-comp @onSearch="attachData" @onReset="onReset">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <CalendarRange v-model="datetimeRange" mode="date" />
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Mã đặt phòng</div>
                    <div>
                      <input v-model="searchParams.recode" type="text" />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Công ty, đại lý du lịch</div>
                    <div>
                      <select-with-search-table
                        style="width: 100%"
                        :rows="agentOptions"
                        :columns="columnsAgent"
                        index-field="id"
                        :dropdown-width="480"
                        :selected-index-field-value="searchParams.agentId"
                        :value="searchParams.agentId"
                        @selectionChanged="onSelectRowAgent"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.name }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo chi tiết đại lý</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="tableLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              :dom-layout="'scroll'"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              class="agGrid"
              :auto-size-cell="true"
              :pinned-bottom-row-data="pinnedBottomRowData"
              :enable-cell-text-selection="true"
              :ensure-dom-order="true"
              @selectionChanged="onSelectRow"
            />
            <!-- aggridReport -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Mã đặt phòng: Mã nhóm / đoàn / khách lẻ</li>
            <li>
              Người lớn: Tổng số lượng người lớn trong nhóm / đoàn / khách lẻ
            </li>
            <li>
              Trẻ em: Tổng số lượng trẻ em + trẻ em &lt; 5t trong nhóm / đoàn /
              khách lẻ
            </li>
            <li>Số phòng: Số lượng phòng đặt của nhóm / đoàn / khách lẻ</li>
            <li>Số đêm: Tổng số đêm ở của đoàn / nhóm /khách lẻ</li>
            <li>
              Doanh thu: Doanh thu thực (Doanh thu tất cả các loại dịch vụ - vé
              - giảm giá - hoàn)
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getAgent } from '@/api/reception/common.js'
import {
  // eslint-disable-next-line no-unused-vars
  getAgencyDetailReportApi,
  // eslint-disable-next-line no-unused-vars
  getAgencyDetailReportExcelApi
} from '@/api/report_service/report'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'

import InfoBtn from './components/InfoBtn.vue'

export default {
  components: {
    CalendarRange,
    InfoBtn,
    SelectWithSearchTable
  },
  data() {
    return {
      agentIdParam: null, // url query param
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      tableLoading: false,
      dialogFormVisible: false,
      agentOptions: [],
      columnsAgent: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          minWidth: 80
        },
        {
          headerName: 'Tên công ty, đại lý du lịch',
          field: 'name',
          tooltipField: 'name',
          flex: 1,
          minWidth: 200
        }
      ],
      searchParams: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        agentId: null,
        recode: null
      },
      searchParamsDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        agentId: null,
        recode: null
      },
      selectAgent: null,
      columns: [
        {
          headerName: 'Mã đặt phòng',
          field: 'recode',
          tooltipField: 'recode',
          minWidth: 200,
          // maxWidth: 80,
          sortable: false
        },
        {
          headerName: 'Người lớn',
          field: 'adult',
          tooltipField: 'adult',
          // width: 100,
          minWidth: 100,
          // maxWidth: 120,
          flex: 1,
          sortable: false
        },
        {
          headerName: 'Trẻ em',
          field: 'child',
          tooltipField: 'child',
          minWidth: 100,
          // maxWidth: 150,
          sortable: false
        },
        {
          headerName: 'Số phòng',
          field: 'number_room',
          tooltipField: 'number_room',
          minWidth: 100,
          // maxWidth: 150,
          sortable: false
        },
        {
          headerName: 'Số đêm',
          field: 'night',
          tooltipField: 'night',
          minWidth: 100,
          // maxWidth: 150,
          sortable: false
        },
        {
          headerName: 'Doanh thu',
          field: 'revenue',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right',
          minWidth: 200,
          // maxWidth: 250,
          // tooltipField: 'revenue',
          sortable: false
        }
      ],
      rows: [],
      pinnedBottomRowData: []
    }
  },
  computed: {
    datetimeRange: {
      get() {
        return {
          start: this.searchParams.dateFrom,
          end: this.searchParams.dateTo
        }
      },
      set(val) {
        this.searchParams.dateFrom = val.start
        this.searchParams.dateTo = val.end
      }
    }
  },
  async created() {
    const { agentId, dateFrom, dateTo } = this.$route.query

    this.searchParamsDefault = {
      ...this.searchParamsDefault,
      agentId: agentId,
      dateFrom: dateFrom
        ? this.$moment(dateFrom).format('YYYY-MM-DD')
        : this.searchParamsDefault.dateFrom,
      dateTo: dateTo
        ? this.$moment(dateTo).format('YYYY-MM-DD')
        : this.searchParamsDefault.dateTo
    }
    this.searchParams = {
      ...this.searchParamsDefault
    }
    await this.getListAgent()
    await this.attachData()
  },
  methods: {
    async handleCommand(cmmd) {
      if (cmmd === 'excel') {
        getAgencyDetailReportExcelApi(this.searchParams)
          .then(res => {
            if (res) {
              // const date = this.$moment().format('DD-MM-YYYY')
              const href = URL.createObjectURL(res)
              const link = document.createElement('a')
              link.href = href
              link.setAttribute(
                'download',
                'bao_cao_chi_tiet_dai_ly' +
                  `${
                    this.selectAgent?.name ? `_${this.selectAgent?.name}` : ''
                  }` +
                  '.xlsx'
              )
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              URL.revokeObjectURL(href)
            } else {
              throw new Error(res)
            }
          })
          .catch(error => {
            this.$message({
              type: 'error',
              message: this.$t(
                'errorMsg.' + error.response.data.message || 'default'
              )
            })
          })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListAgent() {
      var res = await getAgent()
      // getAgent
      this.agentOptions = res.data
      if (res?.data?.length) {
        if (!this.searchParamsDefault.agentId) {
          this.searchParams.agentId = res.data[0].id
          this.selectAgent = res.data[0]
        } else {
          this.searchParams.agentId = Number(this.searchParamsDefault.agentId)
          this.selectAgent = res.data.find(
            item => item.id === Number(this.searchParamsDefault.agentId)
          )
        }
      }
    },
    onSelectRowAgent(val) {
      console.debug('[onSelectRowAgent]', val)
      this.searchParams.agentId = val?.id
      this.selectAgent = val
    },
    async attachData() {
      if (
        this.searchParams.dateFrom === null ||
        this.searchParams.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.tableLoading = true
      // reset selected Row
      this.rows = []
      await getAgencyDetailReportApi(this.searchParams)
        .then(res => {
          const data = res.data
          if (data) {
            this.rows = data.data
            this.pinnedBottomRowData = [
              {
                recode: 'Tổng',
                adult: data.total_adult,
                child: data.total_child,
                revenue: data.total_revenue,
                number_room: data.total_room,
                night: data.total_night
              }
            ]
          } else {
            this.rows = []
            this.pinnedBottomRowData = []
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    async onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      await this.attachData()
    }
  }
}
</script>

<style lang="scss" scoped>
.section-box {
  height: 100% !important;
}

/* cho phép bôi đen và copy text trong grid của view này */
:deep(.agGrid .ag-cell) {
  user-select: text;
}

</style>
